import axios from "axios";
import { installClerkInterceptors } from "@/services/api/clerk-interceptors";

export const apiClient = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
    headers: { "Content-Type": "application/json" },
});
installClerkInterceptors(apiClient);
